/** Developers will copy-paste links containing their own language/locale URL params, remove this to avoid showing a different language app store version. */
export function cleanPlaystoreUrl(url: string) {
  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.host === 'play.google.com' && (parsedUrl.searchParams.has('hl') || parsedUrl.searchParams.has('gl'))) {
      parsedUrl.searchParams.delete('hl');
      parsedUrl.searchParams.delete('gl');
      return parsedUrl.toString();
    }
    return url;
  } catch {
    return url;
  }
}

/** Developers will copy-paste links containing their own language/locale URL params, remove this to avoid showing a different language app store version. */
export function cleanAppStoreUrl(url: string) {
  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.host === 'apps.apple.com' && parsedUrl.searchParams.has('l')) {
      parsedUrl.searchParams.delete('l');
      return parsedUrl.toString();
    }
    return url;
  } catch {
    return url;
  }
}
